import React from 'react'

export const contentTypeImages = {
    'Sacred Art': '/media/images/Art.png',
    'Prose': '/media/images/Prose.png',
    'National': '/media/images/National.png',
    'History': '/media/images/History.png',
    'Music': '/media/images/Music.png',
    'Family': '/media/images/Family.png',
    'Recipe': '/media/images/Recipe.png',
  };

  const types = Object.entries(contentTypeImages).map(([name, img]) => ({ name, img }));


const CultureCardTypes = () => {
    return (
      <div className="grid grid-cols-4 gap-4 p-4">
        {types.map((type, index) => (
          <div
            key={index}
            className="bg-gray-100 p-4 rounded-xl shadow-md flex flex-col items-center justify-center"
          >
            <img src={type.img} alt={type.name} className="w-16 h-16 mb-2" />
          </div>
        ))}
      </div>
    );
  };

export default CultureCardTypes